import { render, staticRenderFns } from "./NewScanPage.vue?vue&type=template&id=67e62896"
import script from "./NewScanPage.vue?vue&type=script&lang=js"
export * from "./NewScanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports